import type { MenuType } from '@/ui/models/ga4';
import useTranslations from '@/core/hooks/use-translations';
import Link from '@/ui/components/Link/Link';
import VectorGraphic from '@/ui/components/VectorGraphic/VectorGraphic';
import { useGA4 } from '@/ui/context/ga4';
import cn from '@/ui/utils/cn/cn';

import $ from './LogoLink.module.scss';

type LogoLinkProps = {
  renderOn: MenuType;
  imageClassName?: string;
};

const LogoLink = ({ renderOn, imageClassName }: LogoLinkProps) => {
  const { trackMenuNavigation } = useGA4();
  const t = useTranslations();

  return (
    <Link
      href="/"
      ariaLabel={t('web_general_header_goToHomepage')}
      onClick={() =>
        trackMenuNavigation({
          menu: renderOn,
          menu_path: '/',
          menu_text: 'Go to homepage',
          menu_click: 'picture',
        })
      }
    >
      <VectorGraphic
        name="image-logo"
        className={cn(
          renderOn === 'footer' ? $.footerImage : $.image,
          imageClassName,
        )}
      />
    </Link>
  );
};

export default LogoLink;
